import { DestroyRef, inject,Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { UsabillaService } from '../usabilla.service';
import { CollectUserDataService } from '../utils/collect-user-data.util';
import { BaseGetFeedbackEvent } from './base-event.interface';

@Injectable({ providedIn: 'root' })
export class PageViewEvent implements BaseGetFeedbackEvent {
  private readonly _router = inject(Router);
  private readonly _usabilla = inject(UsabillaService);
  private readonly _destroyRef = inject(DestroyRef);
  private readonly _userDataService = inject(CollectUserDataService);

  public init(): void {
    this._trackNavigationEvents();
  }

  private _trackNavigationEvents(): void {
    this._execute();

    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => this._execute());
  }

  private _execute(): void {
    this._usabilla.executeEvent('virtualPageView');
    this._usabilla.executeEvent('data', {
      custom: this._userDataService.getUserData(),
    });
  }
}
